import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Menu, X, LogIn, LayoutDashboard, LogOut, UtensilsCrossed } from "lucide-react";

const Navbar = ({ transparent }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: "Ana Sayfa" },
    { to: "/menu", label: "Menü" },
    { to: "/#hakkimizda", label: "Hakkımızda" },
    { to: "/#iletisim", label: "İletişim" },
  ];

  const goPanel = () => {
    if (user?.role === "owner" || user?.role === "waiter") nav("/panel");
    else if (user?.role === "customer") nav("/siparislerim");
    else nav("/giris");
  };

  return (
    <header className={`fixed top-0 inset-x-0 z-40 ${transparent ? "glass" : "glass"}`} data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <img src="/cafein-icon.png" alt="CAFE-İN" className="h-10 w-10 object-contain" />
          <span className="font-serif text-2xl gold-text tracking-tight">CAFE-İN</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.label} href={l.to} className="text-sm text-zinc-300 hover:text-[#FFE599] transition-colors" data-testid={`nav-link-${l.label}`}>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/menu" className="btn-outline px-5 py-2.5 rounded-xl text-sm font-medium flex items-center gap-2" data-testid="nav-order-btn">
            <UtensilsCrossed size={16} /> Sipariş Ver
          </Link>
          {user ? (
            <>
              <button onClick={goPanel} className="btn-gold px-5 py-2.5 rounded-xl text-sm flex items-center gap-2" data-testid="nav-panel-btn">
                <LayoutDashboard size={16} /> {user.role === "customer" ? "Siparişlerim" : "Panel"}
              </button>
              <button onClick={() => { logout(); nav("/"); }} className="text-zinc-400 hover:text-white p-2" data-testid="nav-logout-btn" title="Çıkış">
                <LogOut size={18} />
              </button>
            </>
          ) : (
            <Link to="/giris" className="btn-gold px-5 py-2.5 rounded-xl text-sm flex items-center gap-2" data-testid="nav-login-btn">
              <LogIn size={16} /> Giriş
            </Link>
          )}
        </div>

        <button className="md:hidden text-[#FFE599]" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-[#D4AF37]/15 px-5 py-4 flex flex-col gap-3 scale-in" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a key={l.label} href={l.to} onClick={() => setOpen(false)} className="text-zinc-200 py-1.5">{l.label}</a>
          ))}
          <Link to="/menu" onClick={() => setOpen(false)} className="btn-outline px-4 py-2.5 rounded-xl text-center text-sm">Sipariş Ver</Link>
          {user ? (
            <>
              <button onClick={() => { setOpen(false); goPanel(); }} className="btn-gold px-4 py-2.5 rounded-xl text-sm">{user.role === "customer" ? "Siparişlerim" : "Panel"}</button>
              <button onClick={() => { setOpen(false); logout(); nav("/"); }} className="text-zinc-400 py-1.5">Çıkış Yap</button>
            </>
          ) : (
            <Link to="/giris" onClick={() => setOpen(false)} className="btn-gold px-4 py-2.5 rounded-xl text-center text-sm">Giriş</Link>
          )}
        </div>
      )}
    </header>
  );
};

export default Navbar;
